import React from 'react';
import '../App.css';

function Menu() {

    const nome = JSON.parse(localStorage.getItem('usuario_logado')).nome;
    const expirado = (localStorage.getItem('usuario_expirado') === "S");
    const instrutor = (JSON.parse(localStorage.getItem('usuario_logado')).fl_instrutor === '1');

    return (
        <div className="bg-azul border-right" id="sidebar-wrapper">
            <div className="sidebar-heading text-white">{nome}</div>
            <div className="list-group list-group-flush">
                <a href="/inicio" className="list-group-item list-group-item-action bg-azul2 text-white">Início</a>
                {/* <a href={ expirado ? "/inicio" : "/perfil"} className="list-group-item list-group-item-action bg-azul2 text-white">Meu Perfil</a> */}
                <a href={ expirado ? "/inicio" : "/anuidade"} className="list-group-item list-group-item-action bg-azul2 text-white">Anuidade</a>
                <a href={ expirado ? "/inicio" : "/carteira"} className="list-group-item list-group-item-action bg-azul2 text-white">Carteira Digital</a>
                <a href={ expirado ? "/dados" : "/dados"} className="list-group-item list-group-item-action bg-azul2 text-white">Dados Pessoais</a>
                <a href={ expirado ? "/senha" : "/senha"} className="list-group-item list-group-item-action bg-azul2 text-white">Alterar Senha</a>
                <a href={ expirado ? "/inicio" : "/formularios"} className="list-group-item list-group-item-action bg-azul2 text-white">Formulários</a>
                <a href={ expirado ? "/inicio" : "/academias"} className="list-group-item list-group-item-action bg-azul2 text-white">Academias</a>
                { instrutor &&
                <a href={ expirado ? "/inicio" : "/pedidos"} className="list-group-item list-group-item-action bg-azul2 text-white">Pedidos</a>
                }
                <a href="/login" className="list-group-item list-group-item-action bg-azul2 text-white">Sair</a>
            </div>
        </div>
    );
}

export default Menu;
